export const deleteItem = "kRa";
export default {deleteItem};